<script setup>
import { computed, inject } from 'vue';
import TabButton from 'dashboard/components-next/tabbar/TabButton.vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
});

const activeIndex = inject('activeIndex');
const updateActiveIndex = inject('updateActiveIndex');

const active = computed(() => props.index === activeIndex.value);

const onTabClick = () => {
  if (!props.disabled) {
    updateActiveIndex(props.index);
  }
};
</script>

<template>
  <li class="m-0 flex shrink-0" role="presentation">
    <TabButton
      :label="name"
      :count="showBadge ? count : null"
      :active="active"
      :disabled="disabled"
      :compact="isCompact"
      @select="onTabClick"
    />
  </li>
</template>
